import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-parent-pin-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './parent-pin-dialog.component.html',
  styleUrls: ['./parent-pin-dialog.component.scss']
})
export class ParentPinDialogComponent {
  numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  enteredPin = '';
  showError = false;
  errorMessage = '';

  constructor(
    public dialogRef: MatDialogRef<ParentPinDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title?: string }
  ) {}

  enterNumber(num: number) {
    if (this.enteredPin.length < 4) {
      this.enteredPin += num;
      if (this.enteredPin.length === 4) {
        this.submitPin();
      }
    }
  }

  clear() {
    this.enteredPin = '';
    this.showError = false;
  }

  isComplete() {
    return this.enteredPin.length === 4;
  }

  submitPin() {
    this.dialogRef.close(this.enteredPin);
  }

  setError(message: string) {
    this.showError = true;
    this.errorMessage = message;
    this.enteredPin = '';  // Clear the incorrect PIN
  }
}
